<template>
  <div id="app">
    <navbar :items="nav"></navbar>
    <router-view/>
    <b-footer></b-footer>
  </div>
</template>

<script>
import Navbar from "@/components/sections/Navbar";
import Footer from "@/components/sections/Footer";
import AOS from 'aos';

export default {
  components: {
    'b-footer': Footer,
    'navbar': Navbar
  },
  data() {
    return {
      nav: [
        {title: 'Features', href: '/#features', scrollto: '#features'},
        {
          title: 'Solutions',
          children: [
            {title: 'Planogram Automation', to: {name: 'planogram-automation-software'}},
            {title: 'Retail Execution', to: {name: 'retail-execution-software'}},
            {title: 'Shelf Image Recognition', to: {name: 'shelf-image-recognition'}},
            {title: 'Auto Planogram Generation', to: {name: 'automatic-planogram-generation'}},
            {title: 'POS Fixture Reporting', to: {name: 'pos-fixture-reporting'}},
            {title: 'Brand Logo Recognition', to: {name: 'brand-logo-recognition'}},
          ]
        },
        {
          title: 'Compare',
          children: [
            {title: 'vs Infilect', to: {name: 'compare-infilect'}},
            {title: 'vs ParallelDots', to: {name: 'compare-paralleldots'}},
            {title: 'vs Vispera', to: {name: 'compare-vispera'}},
            {title: 'vs Trax', to: {name: 'compare-trax'}},
            {title: 'vs GoSpotCheck', to: {name: 'compare-gospotcheck'}},
          ]
        },
        {title: 'About Us', to: {name: 'about-us'}},
        {title: 'Contact', href: '/#contact', scrollto: '#contact'},
        {title: 'Blog', to: {name: 'blog'}},
        {title: 'Sign Up', href: 'https://welcome.shelfset.app/auth/register', external: true},
      ]
    }
  },
  created() {
    AOS.init({
      duration: 600,
      once: true
    });
  }
}
</script>
